<template>
	<div class="increased">
		<div class="crumbs">
		    <el-breadcrumb separator=">">
		      <!--<el-breadcrumb-item :to="{ path: '/' }">当前位置</el-breadcrumb-item>-->
		      <span style="float: left;font-size: 100%;font-weight: 700;">当前位置&nbsp;:&nbsp;</span>
			  <el-breadcrumb-item><a style="color:#72ACE3;" >配置中心</a></el-breadcrumb-item>
			  <el-breadcrumb-item>新建模板</el-breadcrumb-item>
			</el-breadcrumb>   
		</div>
		<div class="form-list-argument">
		 	 	<ul>
		        	<li>
			        	<label>模板类型：</label>
			            <el-select v-model="modelType"  v-loading.fullscreen.lock="fullscreenLoading"  @change="getTempList"  placeholder="全部类型" style="height: 35px;">
			              <el-option
			                v-for="item in modelTypeArr"
			                :key="item.value"
			                :label="item.label"
			                :value="item.value">
			              </el-option>
			            </el-select>
			        </li>
			        <li>
			        	
			        	<el-button type="primary" style="width: 40%;" @click="showdialog">新建模板</el-button>
			        </li>
			    </ul>    
		</div>
		
		<div >
			<template>
				<el-table
					:data="tableData"
			      	style="width: 100%">
					<el-table-column label="模板缩略图" width="195" align="center">
			            <template slot-scope="scope">
			              <img class="activity-banner" :src="activityBanner(scope.row.ImgUrl, scope.row.EnumDesc)">
			            </template>
			        </el-table-column>
			      	<el-table-column prop="EnumName" label="模板标题" align="center"></el-table-column>
			      	<el-table-column prop="EnumDesc" label="模板ID" align="center"> </el-table-column>
			      	<el-table-column  label="编辑" align="center">
			      		<template slot-scope="scope">
							<a target="_blank" class="el-icon-edit" title="编辑" @click="edit(scope.row)"></a>
				        </template>	
			      	</el-table-column>
				</el-table>
			</template>
		</div>
		
		<!--模板信息弹窗-->
		<el-dialog  :visible.sync="centerDialogVisible" :show-close= "false" width="700px" height="580px" center>
	    
	      <div>
	      	<ul class="dialog-ul">
	      		<li>
			        <label>模板ID：</label>
			        <el-input v-model="inputId" :disabled="editststus" placeholder="请输入ID"></el-input>    
			    </li>
			    <li>
			        <label>模板名称：</label>
			        <el-input v-model="inputName" placeholder="请输入名称"></el-input>    
			    </li>
			    <li>
			        <label>模板类型：</label>
			        <el-select v-model="ReportmodelType"  @change="isshowProp(ReportmodelType)" placeholder="全部类型" style="height: 35px;">
			              <el-option
			                v-for="item in modelTypeArr"
			                :key="item.value"
			                :label="item.label"
			                :value="item.value">
			              </el-option>
			        </el-select> 
			    </li>
			    
			    <li v-show="propStatus">
			        <label>弹窗类型：</label>
			        <el-select v-model="exposureType"  placeholder="全部类型" style="height: 35px;">
			              <el-option
			                v-for="item in exposureTypeArr"
			                :key="item.value"
			                :label="item.label"
			                :value="item.value">
			              </el-option>
			        </el-select> 
			    </li>
			    <li>
			        <label>编辑模板：</label>
					<el-radio v-model="radio" label="1" style="margin-left: 0;">可编辑</el-radio>
					<el-radio v-model="radio" label="2" style="margin-left: 0;">不可编辑</el-radio>
			    </li>
			    <br />
	      		
	  
	      	</ul>
	      	<div class="uploadbox">
	      		<label>选择图片：</label>
		        <el-upload
				  class="upload-demo"
				  :limit="1"
				  :on-success="uploadSuccess"
				  action="http://plat.adjuz.net/Iad_CustomerTemplate/UploadImg"
				  :on-preview="handlePreview"
				  :on-remove="handleRemove"
				  :file-list="fileList2"
				  list-type="picture">
				  <el-button size="small" type="primary">点击上传</el-button>
				  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
				</el-upload>
	      	</div>
	      </div>
	      <span slot="footer" class="dialog-footer" style="margin-top: 60px;display: inline-block;">
	        <el-button @click="close">取 消</el-button>
	        <el-button type="primary" @click="SaveTemplate">确 定</el-button>
	      </span>
	    </el-dialog>
		
		
	</div>
</template>

<script >
	import {GetListTemplate,SaveTemplate} from 'api/create-activity'   //获取模板列表接口
	export default{
		data() {
			
			return{
				radio:"1",          //1  可编辑模板   2不可编辑模板
				fullscreenLoading: false,
				propStatus:false,    //是否显示弹窗类型
				ReportmodelType:"",  //要提交的模板类型
				exposureType:"", //弹层类型
				exposureTypeArr:[
					{
			          value:"",
			          label:"请选择"
			        },
					{
			          value:0,
			          label:"直接曝光"
			        },
			        {
			          value:1,
			          label:"间接曝光"
			        }
				],	//弹层类型数组
				inputId:"",    //模板ID
				inputName:"",  //模板名称
				modelType:"",  //筛选模板类型
				modelTypeArr:[     //模板类型数组
					{
			          value:"",
			          label:"请选择"
			        },
					{
			          value:"IadActivity",
			          label:"活动模板"
			        },
			        {
			          value: "ConferenceActivity",
			          label: '会场模板'
			        },
			        {
			          value: "BuoyActivity",
			          label: '浮标模板'
			        },
			        {
			          value: "IadLayerActivity",
			          label: '弹层模板'
			        }
				],
				tableData:[],
				centerDialogVisible:false, //弹窗是否显示
				fileList2: [],
				editststus:false,
				imgurl:""
			}
		},
		methods:{
			close(){
				this.inputId = "";
				this.inputName = "";
				this.ReportmodelType = "";
				this.centerDialogVisible = false;
				this.fileList2 = [];
				this.imgurl = ""
			},
			showdialog(){
				this.editststus = false;
				this.centerDialogVisible = true;
				this.inputId = "";
				this.inputName = "";
				this.ReportmodelType = "";
				this.imgurl = "datas.ImgUrl";
			},
//			编辑模板方法
			edit(datas){
				this.centerDialogVisible = true;
				this.inputId = datas.EnumDesc;
				this.inputName = datas.EnumName;
				this.ReportmodelType = datas.BusiCode;
				this.editststus = true;
				this.imgurl = datas.ImgUrl;
				this.radio = String(datas.EditMode);
				if(datas.ExposureMode == -1){//证明不是 弹窗
					
				}else{
					this.exposureType = datas.ExposureMode
				}
			},
//			获取模板列表
			getTempList(){
				this.fullscreenLoading = true;
				let typeid ;
				if(this.modelType == "IadActivity"){  //活动模板
					typeid =0
				}
				if(this.modelType == "ConferenceActivity"){  //会场模板
					typeid =1
				}
				if(this.modelType == "IadLayerActivity"){  //弹窗模板
					typeid =2
				}
				if(this.modelType == "BuoyActivity"){  //浮标模板
					typeid =3
				}
				
				GetListTemplate({
					typeid:typeid,
					editmode:1,
					ismanage:1
				}).then(res=>{
					this.fullscreenLoading = false;
					this.tableData = res
				})
			},
//			是否显示弹窗类型
			isshowProp(ReportmodelType){
				if(ReportmodelType == "IadLayerActivity"){   //证明是弹窗
					this.propStatus = true
				}else{
					this.propStatus = false
				}
			},
			 // 错误提示
		    errorPrompt (type, message) {
		      this.$message({
		        type,
		        message
		      })
		    },
//			保存模板
			SaveTemplate(){
				var picUrlName;
				const isedit = Number(this.radio);
				if(this.editststus== true){     //证明是编辑保存
					if(this.fileList2.length == 0){  //证明没有选  图片
						if(this.imgurl == ""){
							this.errorPrompt('warning', '请上穿模板图片');
							return
						}else{
							picUrlName = this.imgurl
						}
						
					}else{
						picUrlName = "//static.qianmaiapp.com/" +this.fileList2[0].response.Remark;
					}
					
				}else{    //证明是新建保存
					if(this.fileList2.length == 0){
						this.errorPrompt('warning', '请上穿模板图片');
						return
					}else{
						picUrlName = "//static.qianmaiapp.com/" +this.fileList2[0].response.Remark;
					}
					
				}

				console.log(picUrlName);
				SaveTemplate({
					BusiCode:this.ReportmodelType,      //模板类型
					EnumDesc:this.inputId,		//ID
					EnumName:this.inputName,		//名称
					ImgUrl:picUrlName,			//图片地址
					EditMode:isedit,		//是否可编辑
					ExposureMode:this.ReportmodelType == "IadLayerActivity"?this.exposureType:-1//曝光方式
					
				}).then(res=>{ 
					if(res.Success == true){
						this.centerDialogVisible = false;
						this.editststus = false;
						this.fileList2 = [];
						this.imgurl = "";
//						当保存完刷新页面
						this.modelType = this.ReportmodelType;
						this.getTempList()
					}
					
				})
			},
			uploadSuccess (response, file, fileList) {
			      this.fileList2 = fileList.slice(-1)
			},
			// 设置弹窗banner 没有取默认
		    activityBanner(banner, templateId) {
		        return banner || `//static.adjuz.com/iad/img/${templateId.toLowerCase()}.png`
		    },
		    handleRemove(file, fileList) {
		    },
		    handlePreview(file) {
		    },
		    handleExceed(files, fileList) {
		        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		    },
		},
		created (){
			
		}
		
	}
	
</script>

<style lang="scss" scoped>
	
	.uploadbox{		
		clear: both;
		position: relative;
		.el-button{
			position: absolute;
			left: 15%;
			top: -5%;
		}
		.el-upload__tip{
			margin-top: 30px;
		}
	}
	.form-list-argument, {
	    ul:after {
	      content: '';
	      display: block;
	      clear: both;
	    }
	    ul {
	      margin-top:20px; 
	      :nth-child(4){
	      	margin-right: 10px;
	      }
	      li {
	        float: left;
	        width: 20%;
	        height: 50px;
	        label {
	          display: inline-block;
	          min-width: 30%;
	          max-width: 110px;
	          text-align: right;
	          font-weight: bold;
	        }
	        .el-input {
	          width: 60%;
	        }
	        .el-button {
	          background: cornflowerblue;
	          color: #ffffff;
	          margin-left: 10px;
	        }
	        .el-select {
	          width: 60%;
	        }
	      }
	    }
	}
	.dialog-ul li{
		width: 50%;
		float: left;
		margin-bottom: 30px;
		label {
	          display: inline-block;
	          min-width: 30%;
	          max-width: 110px;
	          text-align: right;
	          font-weight: bold;
	        }
	        .el-input {
	          width: 60%;
	        }
	        .el-button {
	          background: cornflowerblue;
	          color: #ffffff;
	          margin-left: 10px;
	        }
	        .el-select {
	          width: 60%;
	        }
	}
	
	/*弹窗banner*/
	.activity-banner {
	    max-width: 187px ;
	    max-height: 82px;
	    border: none;
	}
</style>
<style lang="scss" scoped>
	.el-dialog__wrapper .el-dialog__footer{
		margin-top: 100px;
	}
</style>


// WEBPACK FOOTER //
// src/components/increasedTemplate/increasedTemplate.vue